import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersStudentsTestedInBaselineMidlineEndline = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Students tested in baseline / midline / endline (%)" />
    </Box>
  );
};
